import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import { AUTH } from '@/config'

const REPLACED_KEY = 'uotsSharedSessionReplaced'
const HEARTBEAT_MS = 30_000

// The legacy Vue CLI type checker unwraps ref() to string; retain its runtime Ref shape.
export const replacedMessage = ref('') as unknown as { value: string }
let state: 'active' | 'replaced' | 'invalid' = 'active'
let heartbeat: ReturnType<typeof setInterval> | undefined
let probing = false

const authUrl = (action: 'login' | 'logout') =>
  `${window.location.origin}${AUTH}/${action}`

export const isSessionBlocked = () => state !== 'active'

export function acceptAccessToken(token: string) {
  localStorage.setItem('Authorization', token)
  sessionStorage.removeItem(REPLACED_KEY)
  replacedMessage.value = ''
  state = 'active'
}

export function startLogin() {
  window.location.replace(authUrl('login'))
}

export function stopSessionHeartbeat() {
  if (heartbeat) clearInterval(heartbeat)
  heartbeat = undefined
}

export function exitToLogin() {
  stopSessionHeartbeat()
  state = 'invalid'
  sessionStorage.removeItem(REPLACED_KEY)
  sessionStorage.removeItem('my-data')
  localStorage.removeItem('Authorization')
  localStorage.removeItem('userId')
  window.location.replace(authUrl('logout'))
}

export function recoverReplacedOnLoad(): boolean {
  if (!sessionStorage.getItem(REPLACED_KEY)) return false
  exitToLogin()
  return true
}

export function handleSessionFailure(status: number, data: { code?: number; msg?: string; message?: string } | null): boolean {
  if (status !== 401) return false
  const code = Number(data?.code)
  if (code !== 10409 && code !== 10401) return false
  if (state !== 'active') return true
  stopSessionHeartbeat()
  if (code === 10409) {
    state = 'replaced'
    sessionStorage.setItem(REPLACED_KEY, '1')
    replacedMessage.value = data?.msg || '您的账号在别处登录'
  } else {
    state = 'invalid'
    ElMessage.error(data?.msg || data?.message || '登录已失效，请重新登录')
    window.setTimeout(exitToLogin, 800)
  }
  return true
}

export function startSessionHeartbeat(probe: () => Promise<unknown>) {
  stopSessionHeartbeat()
  heartbeat = setInterval(async () => {
    // OAuth 回跳的 token 可能晚于 App 挂载写入；定时器应始终启动。
    if (!localStorage.getItem('Authorization') || probing || state !== 'active') return
    probing = true
    try {
      await probe()
    } catch {
      // Network and server errors keep the local session for a later retry.
    } finally {
      probing = false
    }
  }, HEARTBEAT_MS)
}
